import { useAuthQueryKey } from '@repo/ui/libs/authQueryBoundary'
import { useQuery } from '@tanstack/vue-query'
import { authApi } from '@client-streamer/libs/eden'
import { useAuthStore } from '@repo/ui'

export function useUserInfoQuery() {
  const authStore = useAuthStore()

  return useQuery({
    queryKey: useAuthQueryKey(() => ['user', 'info']),
    queryFn: async () => {
      const { data, error } = await authApi.user.info.get()
      if (error) throw error
      return data
    },
    enabled: () => authStore.isAuthenticated,
  })
}
